import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AddLoadModule } from './add-load/add-load.module';
import { AddLoadingSpaceModule } from './add-loading-space/add-loading-space.module';
import { MenuItemComponent } from './components/menu-item/menu-item.component';
import { LoadsListModule } from './loads-list/loads-list.module';
import { MainPanelComponent } from './main-panel.component';
import { OpenSharedProjectComponent } from './open-shared-project/open-shared-project.component';

@NgModule({
  declarations: [
    MainPanelComponent,
    MenuItemComponent,
    OpenSharedProjectComponent,
  ],
  imports: [CommonModule, SharedModule, LoadsListModule, AddLoadModule, AddLoadingSpaceModule],
  exports: [
    MainPanelComponent,
    LoadsListModule,
    AddLoadingSpaceModule,
    AddLoadModule,
  ],
})
export class MainPanelModule {}
